import { create } from 'zustand';

import { VabsParticipantType, VabsPaymentSystem } from '@/shared/api';

import { SendMoneyFormData } from './schema_new';
import { SendMoneySteps } from './types';

interface SendMoneyState {
  step: SendMoneySteps;
  type: VabsParticipantType;
  paymentSystem: VabsPaymentSystem | null;
  amount: string;
  data?: SendMoneyFormData;
}
interface SendMoneyActions {
  setStep: (step: SendMoneySteps) => void;
  setType: (type: VabsParticipantType) => void;
  setPaymentSystem: (system: VabsPaymentSystem) => void;
  setAmount: (amount: string) => void;
  updateFormData: (data: Partial<SendMoneyFormData>) => void;
  resetData: VoidFunction;
}

export type SendMoneyStore = SendMoneyState & SendMoneyActions;

const initialState: SendMoneyState = {
  step: 'info',
  type: null,
  amount: '',
  paymentSystem: null,
  data: {} as SendMoneyFormData,
};

export const useSendMoney = create<SendMoneyStore>((set) => ({
  ...initialState,
  setStep: (step: SendMoneySteps) => {
    set({ step });
  },
  setType: (type: VabsParticipantType) => {
    set({ type });
  },
  setPaymentSystem: (paymentSystem: VabsPaymentSystem) => {
    set({ paymentSystem });
  },
  setAmount: (amount: string) => {
    set({
      amount,
    });
  },
  updateFormData: (data: Partial<SendMoneyFormData>) => {
    set((state) => ({
      data: {
        ...state.data,
        ...data,
      },
    }));
  },
  resetData: () => {
    set(initialState);
  },
}));
